// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginModule } from '../login/login.module';
import { MaterialModule } from '../shared/material.module';
import { SharedModule } from '../shared/shared.module';
import { ChangePasswordModalComponent } from './change-password-modal/change-password-modal.component';
import { ChangeSignatureModalComponent } from './change-signature-modal/change-signature-modal.component';
import { DealCreatedModalComponent } from './deal-created-modal/deal-created-modal.component';
import { DealDocumentsDownloadModalComponent } from './deal-documents-download-modal/deal-documents-download-modal.component';
import { DeleteDealModalComponent } from './delete-deal-modal/delete-deal-modal.component';
import { DeleteTemplateModalComponent } from './delete-template-modal/delete-template-modal.component';
import { DeleteDocumentModalComponent } from './document-delete-modal/document-delete-modal.component';
import { DocumentStatusModalComponent } from './document-status-modal/document-status-modal.component';
import { DownloadModalComponent } from './download-modal/download-modal.component';
import { EditUserInfoModalComponent } from './edit-user-info-modal/edit-user-info-modal.component';
import { EditPasswordSettingsModalComponent } from './edit-password-settings-modal/edit-password-settings-modal.component';
import { ErrorModalComponent } from './error-modal/error-modal.component';
import { SubmitWithDataModalComponent } from './submitWithData-modal/submitWithData-modal.component';
import { CustomTwoButtonSubmitComponent } from './customTwoButtonSubmit-modal/customTwoButtonSubmit-Modal.component';
import { SuccessModalComponent } from './success-modal/success-modal.component';
import { VehicleSearchModal } from './vehicle-search-modal/vehicle-search-modal.component';
import { FinalDocModalComponent } from './final-doc-modal/final-doc-modal.component';
import { AuditTrailModalComponent } from './audit-trail-modal/audit-trail-modal.component';
import { PipesModule } from '../pipes/pipes.module';
import { ConfirmModalComponent } from './confirm-modal/confirm-modal.component';
import { SystemDocumentModalComponent } from './system-document-modal/system-document-modal.component';
import { AddDocumentsModalComponent } from './add-documents-modal/add-documents-modal.component';
import { EditVehicleInfoModalComponent } from './edit-vehicle-info-modal/edit-vehicle-info-modal.component';
import { SSOSuccessVideoModalComponent } from './sso-success-video-modal/sso-success-video-modal.component';
import { EditLeadModalComponent } from './edit-lead-modal/edit-lead-modal.component';
import { FileSizeErrorModalComponent } from './file-size-error-modal/file-size-error-modal.component';
import { FileSizeErrorPDDJModalComponent } from './file-size-error-modal/file-size-error-PDDJ-modal.component';
import { EditStorageJacketModalComponent } from './edit-storage-jacket-modal/edit-storage-jacket-modal.component';
import { InternalDocumentInterventionModalComponent } from './internal-document-intervention-modal/internal-document-intervention-modal.component';
import { IdUnverifiedModalComponent } from './id-unverified-modal/id-unverified-modal.component';
import { R1JacketModalComponent } from './r1-jacket-modal/r1-jacket-modal.component';
import { R1UserDataModalComponent } from './r1-jacket-modal/r1-user-data-modal.component';
import { MobileOnlyUploadModalComponent } from './mobile-only-upload-modal/mobile-only-upload-modal.component';
import { EditNameModalComponent } from './edit-name-modal/edit-name-modal.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { LightweightPdfViewModalComponent } from './lightweight-pdf-view-modal/lightweight-pdf-view-modal.component';
import { EditProductModalComponent } from './edit-product-modal/edit-product-modal.component';
import { ChangeDealershipModalComponent } from './change-dealership-modal/change-dealership-modal.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { AddCobuyerModalComponent } from './add-cobuyer-modal/add-cobuyer-modal.component';
import { NotarizeModalComponent } from './notarize-modal/notarize-modal.component';
import { MultiSelectModalComponent } from './multi-select-modal/multi-select-modal.component';
import { EditDealInfoModalComponent } from '../dealer/deal-container/edit-deal-Info/edit-deal-info-modal.component';
import { EditNotesModalComponent } from './edit-notes-modal/edit-notes-modal.component';
import { RestoreDocumentModalComponent } from './document-restore-modal/document-restore-modal.component';
import { NetworkTestModalComponent } from './network-test-modal/network-test-modal.component';
import { SystemMessageModalComponent } from './system-message-modal/system-message-modal.component';

@NgModule({
    declarations: [
        AddCobuyerModalComponent,
        AddDocumentsModalComponent,
        AuditTrailModalComponent,
        ChangeDealershipModalComponent,
        ChangePasswordModalComponent,
        ChangeSignatureModalComponent,
        ConfirmModalComponent,
        CustomTwoButtonSubmitComponent,
        DealCreatedModalComponent,
        DealDocumentsDownloadModalComponent,
        DeleteDealModalComponent,
        DeleteDocumentModalComponent,
        DeleteTemplateModalComponent,
        DocumentStatusModalComponent,
        DownloadModalComponent,
        EditDealInfoModalComponent,
        EditLeadModalComponent,
        EditNameModalComponent,
        EditNotesModalComponent,
        EditPasswordSettingsModalComponent,
        EditProductModalComponent,
        EditStorageJacketModalComponent,
        EditUserInfoModalComponent,
        EditVehicleInfoModalComponent,
        ErrorModalComponent,
        FileSizeErrorModalComponent,
        FileSizeErrorPDDJModalComponent,
        FinalDocModalComponent,
        IdUnverifiedModalComponent,
        InternalDocumentInterventionModalComponent,
        LightweightPdfViewModalComponent,
        MobileOnlyUploadModalComponent,
        MultiSelectModalComponent,
        NetworkTestModalComponent,
        NotarizeModalComponent,
        R1JacketModalComponent,
        R1UserDataModalComponent,
        SSOSuccessVideoModalComponent,
        SubmitWithDataModalComponent,
        SuccessModalComponent,
        SystemDocumentModalComponent,
        VehicleSearchModal,
        RestoreDocumentModalComponent,
        SystemMessageModalComponent,
    ],
    imports: [CommonModule, FormsModule, LoginModule, MaterialModule, PipesModule, ReactiveFormsModule, SharedModule, PdfViewerModule, ScrollingModule],
})
export class ModalsModule {}
